export enum ActivityType {
    Invites = 'Invites',               // Einladungen
    OtherComponent = 'OtherComponent', // Weitere Komponenten hier hinzufügen
  }
  